import React, { useState } from 'react';
import { login } from '../utils/api';

function Login({ setIsAuthenticated, setEncSalt, setMasterPassword }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { token, enc_salt } = await login(password);
      localStorage.setItem('sessionToken', token);
      setEncSalt(enc_salt);
      setMasterPassword(password); // Pass the master password
      setIsAuthenticated(true);
    } catch (err) {
      setError('Invalid password');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <form onSubmit={handleSubmit} className="p-6 bg-white dark:bg-gray-800 rounded shadow-md">
        <h2 className="text-2xl mb-4">Login</h2>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Master Password"
          className="w-full p-2 mb-4 border rounded dark:bg-gray-700 dark:text-white"
        />
        {error && <p className="text-red-500 mb-4">{error}</p>}
        <button type="submit" className="w-full p-2 bg-blue-500 text-white rounded hover:bg-blue-600">
          Login
        </button>
      </form>
    </div>
  );
}

export default Login;